@if (items?.length) {
  <div class="chart-legend">
    @for (item of items; track item.label; let index = $index) {
      <button
        type="button"
        class="chart-legend-item"
        [class.chart-legend-item--with-value]="item.value !== undefined"
        [class.chart-legend-item--off]="!item.active"
        [attr.data-legend-index]="item.color ? null : item.colorIndex"
        [style.--legend-color]="item.color ?? null"
        [attr.aria-pressed]="item.active"
        (click)="toggleSeries.emit(index)">
        <span class="chart-legend-item-top">
          <span class="chart-legend-dot"></span>
          <span class="chart-legend-label" [attr.title]="item.label">{{ item.label }}</span>
        </span>
        @if (item.value !== undefined) {
          <span class="chart-legend-value" [matTooltip]="item.tooltip ?? ''" matTooltipPosition="above">{{ item.value }}</span>
        }
      </button>
    }
  </div>
}
